import { reducer } from './reducers'
export * from './reducers'
export * from './selectors'
export * from './epics'
export * from './actions'

export default reducer
